import { IUsuario } from "@/interfaces/usuarios.interface";

/**
 * Declaração de tipo para o dataLayer do Google Tag Manager
 */
declare global {
  interface Window {
    dataLayer?: any[];
  }
}

/**
 * Função genérica para fazer push no dataLayer do GTM
 * @param data - Dados a serem enviados para o dataLayer
 */
export function pushToDataLayer(data: Record<string, any>): void {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push(data);
  }
}

/**
 * Envia dados do usuário autenticado para o dataLayer
 * @param user - Objeto do usuário autenticado
 * @param loginId - ID do login selecionado (opcional)
 */
export function setUserData(user: IUsuario, loginId?: number | null): void {
  if (!user || !user.id) return;

  pushToDataLayer({
    event: "user_data",
    user: {
      user_id: user.id,
      user_name: user.name || "",
      user_master: user.Master || false,
      login_id: loginId || null,
    },
  });

  // Também envia evento de login
  pushToDataLayer({
    event: "user_login",
    user_id: user.id,
  });
}

/**
 * Limpa os dados do usuário do dataLayer (usado no logout)
 */
export function clearUserData(): void {
  pushToDataLayer({
    event: "user_logout",
  });

  // Limpa os dados do usuário
  pushToDataLayer({
    event: "user_data",
    user: {
      user_id: null,
      user_name: null,
      user_master: false,
      login_id: null,
    },
  });
}

/**
 * Envia dados do evento selecionado para o dataLayer
 * @param eventoId - ID do evento selecionado
 * @param eventoTitulo - Título do evento (opcional)
 */
export function setEventData(
  eventoId: number | null,
  eventoTitulo?: string
): void {
  pushToDataLayer({
    event: "evento_selected",
    evento: {
      evento_id: eventoId,
      evento_titulo: eventoTitulo || null,
    },
  });
}

